import { useCallback, useEffect, useRef } from 'react';



const usePolling = (fetchFunction, options = { interval: 500, type: "short" }) => {
    const { interval, type } = options;

    const isPolling = useRef(true);
    const intervalId = useRef(null);

    const stopPolling = useCallback(() => {
        isPolling.current = false;
        if (type === 'short' && intervalId?.current) {
            clearInterval(intervalId?.current);
            intervalId.current = null;
        }
    }, [type]);

    useEffect(() => {
        const shortPolling = () => {
            intervalId.current = setInterval(() => {
                if (isPolling.current) {
                    fetchFunction();
                }
            }, interval);

            return () => clearInterval(intervalId);
        };


        const longPolling = async () => {
            while (isPolling.current) {
                try {
                    await fetchFunction();
                } catch (error) {
                    console?.error("Error in long polling", error);
                }
            }
        };



        if (type === "short") {
            return shortPolling();
        } else if (type === "long") {
            isPolling.current = true;
            longPolling();
            return () => {
                isPolling.current = false;
            };
        }
        return () => {
            stopPolling();
        };
    }, [fetchFunction, interval, type, stopPolling]);
    return { stopPolling };
};


export default usePolling;